import { useTranslation } from "react-i18next";
import useModalStore from "store/modal";
import { detail } from "./handles";
import ListHead from "components/subHead/listHead";
import Grid from "components/grid";
import { useSearchList } from "./service";
import RoomProductDetail from "./detail";
import { workerData } from "worker_threads";

type IListProps = {};

export default function RoomProductList({}: IListProps) {
  const { t } = useTranslation();
  const { rowData, pageNav } = useSearchList();
  const onSetModal = useModalStore((state) => state.onSetModal);

  const theads = [
    ...prevTheads,
    {
      langNm: "grid_detail",
      type: "detail",
      field: "detail",
      width: 80,
      click: (props: any) => {
        detail(props);

        // 상세 모달창 오픈
        onSetModal({
          title: t("md_ttl_rm_hst"),
          isOpen: true,
          inner: <RoomProductDetail />,
          styles: "w-full",
        });
      },
    },
  ];

  const cellstyle = (params: any) => {
    const histStaTyp = params.data.histStaTyp;
    const sellYn = params.data.sellYn;
    const histColor =
      histStaTyp === "C"
        ? "#38b000"
        : histStaTyp === "U"
        ? "#0d3b66"
        : histStaTyp === "D"
        ? "#d90429"
        : "#2b2d42";
    const sellYnColor =
      sellYn === "Y" ? "#38b000" : sellYn === "N" ? "#d90429" : "#2b2d42";

    const color =
      params.colDef.field === "histStaTypNm"
        ? histColor
        : params.colDef.field === "sellYnNm"
        ? sellYnColor
        : "#2b2d42";
    return {
      color: color,
      fontWeight:
        params.colDef.field === "histStaTypNm" ||
        params.colDef.field === "sellYnNm"
          ? "bold"
          : "400",
    };
  };

  return (
    <>
      <ListHead totalRows={pageNav?.totalRows || 0} />
      <Grid
        theads={theads}
        rowData={rowData}
        cellstyle={cellstyle}
        pageNav={pageNav}
      />
    </>
  );
}

const prevTheads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 60,
  },
  {
    langNm: "grid_rm_no",
    type: "string",
    field: "rmNo",
    width: 180,
  },
  {
    langNm: "grid_status",
    type: "string",
    field: "sellYnNm",
    width: 80,
  },
  {
    langNm: "grid_rm_nm",
    type: "string",
    field: "rmNm",
  },
  {
    langNm: "grid_rm_typ",
    type: "string",
    field: "rmTypNm",
    width: 120,
  },

  {
    langNm: "grid_rm_op_nm",
    type: "string",
    field: "rmOpNm",
    width: 120,
  },
  {
    langNm: "grid_pd_price",
    type: "price",
    field: "sellPri",
  },
  {
    langNm: "grid_resv_no",
    type: "string",
    field: "rmPdNo",
  },

  {
    langNm: "grid_sell_dt",
    type: "date",
    field: "sellDt",
    width: 120,
  },
  {
    langNm: "grid_rmpd_day",
    type: "string",
    field: "day",
    width: 80,
  },
  {
    langNm: "grid_rmpd_ct",
    type: "number",
    field: "rmPdCt",
    width: 100,
  },
  // {
  //   langNm: "grid_rmpd_sell_ct",
  //   type: "number",
  //   field: "sellYCt",
  //   width: 100,
  // },
  // {
  //   langNm: "grid_rmpd_sell_n_ct",
  //   type: "number",
  //   field: "sellNCt",
  //   width: 100,
  // },
  // {
  //   langNm: "grid_resv_qt",
  //   type: "number",
  //   field: "resvCt",
  //   width: 100,
  // },

  // {
  //   langNm: "grid_acsr_no",
  //   type: "string",
  //   field: "acsrNo",
  //   width: 140,
  // },
  // {
  //   langNm: "grid_memo",
  //   type: "string",
  //   field: "memo",
  //   width: 400,
  // },
  // {
  //   langNm: "grid_hst_typ",
  //   type: "string",
  //   field: "histStaTypNm",
  //   width: 80,
  // },
];
